module.exports = __webpack_public_path__ + "img/LY.13bccc1e.png";